// Form 4473 / bound-book / driver-license helpers.

import {
  BoundBookEntry,
  Form4473FFL,
  Form4473Firearm,
  Form4473Transferee,
} from '../models/general';
import { DriverLicense } from '../models/drivers-license-parser';

export function getBoundBookEntriesByIds(
  sharedService: any,
  ids: string[],
): BoundBookEntry[] {
  return sharedService.bound_book.filter((entry) =>
    ids.includes(entry.bound_book_id),
  );
}

export function boundBookEntriesToForm4473Firearms(
  entries: BoundBookEntry[] = [],
): Form4473Firearm[] {
  return entries.filter(Boolean).map((e) => {
    const f = new Form4473Firearm();
    f.firearm_id =
      typeof e.firearm_id === 'number'
        ? e.firearm_id
        : Number(e.firearm_id) || 0;
    f.firearm_type = e.a_firearm_type ?? e.a_firearm_type ?? '';
    f.manufacture = e.a_manufacture ?? '';
    f.importer = e.a_importer ?? '';
    f.model = e.a_model ?? '';
    f.additional_markings = e.a_additional_markings ?? '';
    f.caliber_gauge = e.a_caliber_gauge ?? '';
    f.serial_number = e.a_serial_number ?? '';
    return f;
  });
}

export function createForm4473FFL(sharedService): Form4473FFL {
  const ffl: Form4473FFL = new Form4473FFL();
  ffl.ffl = sharedService.company_info.ffl;
  ffl.legal_name = sharedService.company_info.legal_name;
  ffl.company_name = sharedService.company_info.company_name;
  ffl.address = sharedService.company_info.address;
  ffl.address2 = sharedService.company_info.address2;
  ffl.zip_code = sharedService.company_info.zip_code;
  ffl.city = sharedService.company_info.city;
  ffl.state = sharedService.company_info.state;
  return ffl;
}

export function createForm4473Firearm(sharedService): Form4473Firearm[] {
  let firearms: Form4473Firearm[] = [];
  for (const firearm of sharedService.selected_firearms_for_disposition) {
    if (!firearm) {
      console.warn('Skipping undefined firearm selection.');
      continue;
    }
    const firearm_details: BoundBookEntry = sharedService.bound_book.find(
      (bb_firearm) => bb_firearm.firearm_id === firearm.firearm_id,
    );
    if (!firearm_details) {
      console.warn('Bound book entry not found for selected firearm:', firearm);
      continue;
    }
    let f: Form4473Firearm = new Form4473Firearm();
    f.firearm_id = firearm_details.firearm_id;
    f.firearm_type = firearm_details.a_firearm_type;
    f.manufacture = firearm_details.a_manufacture;
    f.importer = firearm_details.a_importer;
    f.serial_number = firearm_details.a_serial_number;
    f.model = firearm_details.a_model;
    f.caliber_gauge = firearm_details.a_caliber_gauge;
    f.additional_markings = firearm_details.a_additional_markings;
    firearms.push(f);
  }
  return firearms;
}

export function findDriverLicense(
  drivers_id: string,
  sharedService: any,
): DriverLicense {
  return sharedService.recent_drivers_license.filter(
    (license) => license.driversId === drivers_id,
  )[0];
}

export function findDriversLicenseByUserInfo(
  sharedService: any,
  transferee: Form4473Transferee,
): DriverLicense {
  return sharedService.recent_drivers_license.filter(
    (license) =>
      license.nameLast === transferee.name_last &&
      license.nameFirst === transferee.name_first &&
      license.addressStreet === transferee.address_street,
  )[0];
}
